import { render, staticRenderFns } from "./EditData.vue?vue&type=template&id=9103a930&scoped=true&"
import script from "./EditData.vue?vue&type=script&lang=js&"
export * from "./EditData.vue?vue&type=script&lang=js&"
import style0 from "./EditData.vue?vue&type=style&index=0&id=9103a930&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9103a930",
  null
  
)

export default component.exports